// SPA routing
import { renderHomePage } from '../pages/home.js';
import { renderPrivacyPage, renderTermsPage } from '../pages/legal.js';
import { renderSupportPage } from '../pages/support.js';
import {getContent, getCurrentPage, setCurrentPage} from './store.js';
import {updatePageMetaTags} from '../utils/dom.js';
import {render404Page} from "../pages/404";

const VALID_PAGES = ['home', 'privacy', 'terms', 'support'];

export function setupRouter() {
    // Set up navigation event listeners
    document.addEventListener('click', handleNavigation);

    // Handle browser back/forward buttons
    window.addEventListener('popstate', handlePopState);

    // Initial routing based on URL
    const initialPage = window.location.pathname ? window.location.pathname.substring(1) : '';
    navigateToPage(initialPage);
}

function handleNavigation(event) {
    // Check if clicked element has data-page attribute
    const targetPage = event.target.getAttribute('data-page') ||
        event.target.closest('[data-page]')?.getAttribute('data-page');

    if (targetPage) {
        event.preventDefault();

        // Update browser history
        if (targetPage === 'home') {
            history.pushState({page: targetPage}, '', '/');
        } else {
            history.pushState({page: targetPage}, '', '/' + targetPage);
        }

        navigateToPage(targetPage);
    }
}

function handlePopState(event) {
    const currentPath = window.location.pathname.substring(1);

    if (event.state && event.state.page) {
        navigateToPage(event.state.page);
    } else {
        navigateToPage(currentPath);
    }
}

export function navigateToPage(pageName) {
    // Handle 404 for invalid routes
    if (pageName !== '' && pageName !== '/' && !VALID_PAGES.includes(pageName)) {
        setCurrentPage('404');
        history.replaceState({page: '404'}, '', '/404');
        render404Page();
        return;
    }

    // Normalise empty/root paths
    if (pageName === '' || pageName === '/') {
        pageName = 'home';
    }

    // Valid route
    setCurrentPage(pageName);

    // Ensure URL is clean
    if (pageName === 'home') {
        if (window.location.pathname !== '/') {
            history.replaceState({page: 'home'}, '', '/');
        }
    } else {
        const currentPath = '/' + pageName;
        if (window.location.pathname !== currentPath) {
            history.replaceState({page: pageName}, '', currentPath);
        }
    }

    // Update page meta tags
    const content = getContent();
    if (content) {
        updatePageMetaTags(content, pageName);
    }

    // Render the appropriate page
    switch(pageName) {
        case 'home':
            renderHomePage();
            break;
        case 'privacy':
            renderPrivacyPage();
            break;
        case 'terms':
            renderTermsPage();
            break;
        case 'support':
            renderSupportPage();
            break;
    }

    // Scroll to top when changing pages
    window.scrollTo(0, 0);
}